module.exports = __webpack_public_path__ + "media/images/pets1-3479c7a747d46010d690e37eeea28b95.jpg";